/**
 * Wait for a specified number of milliseconds before resolving the returned Promise.
 *
 * @param {number} ms - The number of milliseconds to wait for before returning.
 * @returns {Promise<void>}
 */
export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
